import { DefaultIconProps } from "./default-icon/default-icon-props";
import { DefaultIcon } from "./default-icon/default-icon"

export const RecolherIcon = (props: DefaultIconProps) => {
    return (
        <>
            <DefaultIcon tipo={props.tipo} class={props.class} style={props.style} fill={props.fill}>
                <path d="M 25 12.75 L 2.75 35 L 4.84375 37.09375 L 25 16.9375 L 45.15625 37.09375 L 47.25 35 Z"></path>
            </DefaultIcon>
        </>
    );
};